import { Col, Form, Row, Select } from 'antd'
import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react'
import { ShimmerButton } from 'react-shimmer-effects'
import OperationTreeLegacy from 'components/Management/Tree/PowerBI/OperationTree'
import OperationTree from 'components/Management/Tree/PowerBI/OperationTree_New'
import SubOperationTreeLegacy from 'components/Management/Tree/PowerBI/SuboperationTree'
import SubOperationTree from 'components/Management/Tree/PowerBI/SuboperationTree_New'
import TreeSelectProjectGroup from 'components/Management/Tree/PowerBI/projectGroup'
import ProjectCategory from 'components/Management/Tree/PowerBI/projectCategory'
import TreeSelectImpactType from 'components/Management/Tree/PowerBI/impactType'
import { CounterContext } from 'redux/Golbalvalues'
import { getCookie } from 'helper/cookie'
import {
  GET_IMPACTTYPE,
  GET_PROJECT_CATEGORY,
  GET_PROJECT_GROUP_V2,
} from 'api/Admin/powerbi'
const { Option } = Select

// <AdditionalBusiness
// additionalId={index + 1}
// masterData={masterData}
// masterDataImpactType={masterDataImpactType}
// masterDataProjectGroup={masterDataProjectGroup}
// isLoadingMultiForm={isLoadingMultiForm}
// dataSelected={{
//   company_id: 2,
//     operation_id: "41,61",
//     suboperation_id: "42,62",
//     project_group: "309,24",
//     subproject_group: "25,310",
//     impact_type: "105,106"
// }}
// optionCompany={optionCompany}
// setSelected={(e) => {
//   console.log(index + 1,"Akiira Infomation >>>>", e)
// }}
// ></AdditionalBusiness>

const AdditionalBusiness = (props) => {
  const {
    dataSelected,
    additionalId,
    optionCompany,
    optionCompanyActive,
    setSelected,
    isLoadingMultiForm,
    masterDataImpactType,
    masterDataProjectGroup,
    masterData,
    masterDataEdit,
    isEditMode,
    tabCompanyData,
  } = props
  const { form } = useContext(CounterContext)
  const [, setAccountOptions] = useState([])
  const [choiceCompany, setChoiceCompany] = useState([])
  const [choiceOperations, setChoiceOperations] = useState([])
  const [subOperation, setSubOperation] = useState([])
  const [choiceProjectGroup, setChoiceProjectGroup] = useState([])
  const [choiceProjectCategory, setChoiceProjectCategory] = useState([])
  const [choiceImpactType, setChoiceImpactType] = useState([])
  const [tabProjectGroupOptions, setTabProjectGroupOptions] = useState([])
  const [tabProjectCategoryOptions, setTabProjectCategoryOptions] = useState([])
  const [tabImpactTypeOptions, setTabImpactTypeOptions] = useState([])
  const token = getCookie('access_token_admin')

  const parseIds = useCallback((value) => {
    if (!value) return []
    if (Array.isArray(value)) {
      return value.map((item) => item?.toString()).filter(Boolean)
    }
    return String(value)
      .split(',')
      .map((item) => item.trim())
      .filter(Boolean)
  }, [])

  const createNameMap = useCallback(
    (items = [], keys = ['name_en', 'name_th', 'name']) => {
      return (items || []).reduce((result, item) => {
        const id = item?.id?.toString()
        if (!id) return result
        const label = keys.map((key) => item?.[key]).find(Boolean)
        result[id] = label || id
        return result
      }, {})
    },
    [],
  )

  const selectedProjectGroupNameMap = useMemo(
    () => createNameMap(tabCompanyData?.project_group_code),
    [createNameMap, tabCompanyData],
  )

  const selectedProjectCategoryNameMap = useMemo(
    () => createNameMap(tabCompanyData?.subproject_group_code),
    [createNameMap, tabCompanyData],
  )

  const selectedImpactTypeNameMap = useMemo(
    () => createNameMap(tabCompanyData?.impact_type_code),
    [createNameMap, tabCompanyData],
  )

  const choiceImpactTypeInactive = useMemo(() => {
    return (tabCompanyData?.impact_type_code || []).filter((item) => item?.id)
  }, [tabCompanyData])

  const fetchProjectGroupOptions = useCallback(
    async (companyId) => {
      if (!companyId) {
        setTabProjectGroupOptions([])
        return
      }
      const response = await GET_PROJECT_GROUP_V2(token, [companyId])
      setTabProjectGroupOptions(response?.error ? [] : response?.data || [])
    },
    [token],
  )

  const fetchProjectCategoryOptions = useCallback(
    async (companyId, groupIds) => {
      const normalizedGroupIds = Array.isArray(groupIds)
        ? groupIds
        : String(groupIds || '')
            .split(',')
            .filter(Boolean)

      if (!companyId || normalizedGroupIds.length === 0) {
        setTabProjectCategoryOptions([])
        return []
      }

      const response = await GET_PROJECT_CATEGORY(token, [companyId], normalizedGroupIds)
      const newData = response?.error ? [] : response?.data || []
      setTabProjectCategoryOptions(newData)
      return newData
    },
    [token],
  )

  const fetchImpactTypeOptions = useCallback(
    async (companyId) => {
      if (!companyId) {
        setTabImpactTypeOptions([])
        return
      }

      const response = await GET_IMPACTTYPE(token, [companyId])
      setTabImpactTypeOptions(response?.error ? [] : response?.data || [])
    },
    [token],
  )

  useEffect(() => {
    if (!isLoadingMultiForm?.company) {
      setCompany()
    }
    if (!isLoadingMultiForm?.operation) {
      setOperations()
    }
    if (!isLoadingMultiForm?.suboperation) {
      setSubOperations()
    }
    if (!isLoadingMultiForm?.projectgroup) {
      setProjectGroups()
    }
    if (!isLoadingMultiForm?.projectcategory) {
      setSubProjectGroups()
    }
    if (!isLoadingMultiForm?.impacttype) {
      setImpacttype()
    }
  }, [isLoadingMultiForm])

  useEffect(() => {
    const companyId = choiceCompany?.[0]
    fetchProjectGroupOptions(companyId)
    fetchImpactTypeOptions(companyId)
  }, [choiceCompany, fetchImpactTypeOptions, fetchProjectGroupOptions])

  const handleProjectGroupChange = useCallback(
    async (groupIds, options = {}) => {
      const { isInit = false, companyIdOverride } = options
      const normalizedGroupIds = parseIds(groupIds)
      setChoiceProjectGroup(normalizedGroupIds)
      setSelected({
        action: 'project_group',
        value: normalizedGroupIds.toString(),
      })

      const companyId = companyIdOverride || choiceCompany?.[0]
      if (!companyId || normalizedGroupIds.length === 0) {
        setTabProjectCategoryOptions([])
        setChoiceProjectCategory([])
        setSelected({ action: 'subproject_group', value: '' })
        return
      }

      const newCategories = await fetchProjectCategoryOptions(
        companyId,
        normalizedGroupIds,
      )
      if (isInit) return

      const validIds = new Set(newCategories.map((item) => String(item.id)))
      setChoiceProjectCategory((prev) => {
        const filtered = prev.filter((id) => validIds.has(String(id)))
        if (filtered.length !== prev.length) {
          setSelected({
            action: 'subproject_group',
            value: filtered.toString(),
          })
        }
        return filtered
      })
    },
    [choiceCompany, fetchProjectCategoryOptions, parseIds, setSelected],
  )

  const companySelectOptions = optionCompany || []

  const resetDropdownScrollTop = (dropdownClassName) => {
    const setTop = () => {
      const dropdown = document.querySelector(`.${dropdownClassName}`)
      if (!dropdown) return
      const scrollContainer =
        dropdown.querySelector('.rc-virtual-list-holder') ||
        dropdown.querySelector('.rc-virtual-list') ||
        dropdown
      if (scrollContainer) {
        scrollContainer.scrollTop = 0
      }
    }
    requestAnimationFrame(setTop)
    setTimeout(setTop, 50)
  }

  const setCompany = useCallback(() => {
    if (dataSelected && dataSelected.company_id && dataSelected.company_id !== 0) {
      form.setFieldsValue({
        ['project_company_' + additionalId]: parseInt(dataSelected.company_id),
      })
      controllerOptionalOnChange({
        action: 'company',
        value: dataSelected.company_id,
      })
    }
  }, [additionalId, dataSelected, form])

  const setOperations = useCallback(() => {
    if (dataSelected && dataSelected.operation_id && dataSelected.operation_id !== '') {
      const operationId = parseIds(dataSelected.operation_id)
      if (operationId.length > 0) {
        controllerOptionalOnChange({ action: 'operation', value: operationId })
      }
    }
  }, [dataSelected, parseIds])

  const setSubOperations = useCallback(() => {
    if (
      dataSelected &&
      dataSelected.suboperation_id &&
      dataSelected.suboperation_id !== ''
    ) {
      const suboperationId = parseIds(dataSelected.suboperation_id)
      if (suboperationId.length > 0) {
        controllerOptionalOnChange({
          action: 'subOperation',
          value: suboperationId,
        })
      }
    }
  }, [dataSelected, parseIds])

  const setProjectGroups = useCallback(() => {
    if (dataSelected && dataSelected.project_group && dataSelected.project_group !== '') {
      const projectGroupId = parseIds(dataSelected.project_group)
      if (projectGroupId.length > 0) {
        handleProjectGroupChange(projectGroupId, {
          isInit: true,
          companyIdOverride: dataSelected.company_id?.toString(),
        })
      }
    }
  }, [dataSelected, handleProjectGroupChange, parseIds])

  const setSubProjectGroups = useCallback(() => {
    if (
      dataSelected &&
      dataSelected.subproject_group &&
      dataSelected.subproject_group !== ''
    ) {
      const subProjectGroupId = parseIds(dataSelected.subproject_group)
      if (subProjectGroupId.length > 0) {
        controllerOptionalOnChange({
          action: 'subProjectGroup',
          value: subProjectGroupId,
        })
      }
    }
  }, [dataSelected, parseIds])

  const setImpacttype = useCallback(() => {
    if (dataSelected && dataSelected.impact_type && dataSelected.impact_type !== '') {
      const impactTypeId = parseIds(dataSelected.impact_type)
      if (impactTypeId.length > 0) {
        controllerOptionalOnChange({
          action: 'impact_type',
          value: impactTypeId,
        })
      }
    }
  }, [dataSelected, parseIds])

  function controllerOptionalOnChange(value) {
    switch (value.action) {
      case 'company':
        setAccountOptions([])
        setChoiceCompany([value.value.toString()])
        setChoiceOperations([])
        setSubOperation([])
        setChoiceProjectGroup([])
        setChoiceProjectCategory([])
        setTabProjectCategoryOptions([])
        setChoiceImpactType([])
        setSelected({ action: 'company_id', value: value.value })
        break
      case 'operation':
        setAccountOptions([])
        setChoiceOperations(value.value)
        if ((value.value || []).length === 0) {
          setSubOperation([])
          setChoiceProjectGroup([])
          setChoiceProjectCategory([])
          setChoiceImpactType([])
        }
        setSelected({ action: 'operation_id', value: value.value.toString() })
        break
      case 'subOperation':
        setAccountOptions([])
        setSubOperation(value.value)
        setSelected({
          action: 'suboperation_id',
          value: value.value.toString(),
        })
        break
      case 'projectGroup':
        handleProjectGroupChange(value.value, { isInit: false })
        break
      case 'subProjectGroup':
        setChoiceProjectCategory(value.value)
        setSelected({
          action: 'subproject_group',
          value: value.value.toString(),
        })
        break
      case 'impact_type':
        setChoiceImpactType(value.value)
        setSelected({ action: 'impact_type', value: value.value.toString() })
        break
      default:
        break
    }
  }

  return (
    <div key={'additional_business_' + additionalId}>
      <Row style={{ display: 'flex', justifyContent: 'space-between' }}>
        <Col className="col-responsive-width-container">
          <h4 className="label">Business</h4>
          <Form.Item
            id={'project_company_' + additionalId}
            name={'project_company_' + additionalId}
          >
            {!isLoadingMultiForm.company ? (
              <Select
                key={'key_compay_' + additionalId}
                onChange={(e) => {
                  controllerOptionalOnChange({ action: 'company', value: e })
                }}
                virtual={false}
                dropdownClassName={`project-additional-company-dropdown-${additionalId}`}
                onDropdownVisibleChange={(open) => {
                  if (open) {
                    resetDropdownScrollTop(
                      `project-additional-company-dropdown-${additionalId}`,
                    )
                  }
                }}
                disabled={false}
                id={'company_' + additionalId}
                name={'company_name_' + additionalId}
                className="responsive-width"
                size="large"
                placeholder="Business"
                style={{
                  width: '434px',
                  marginBottom: '10px',
                  border: '1px solid #E4E7EC',
                }}
              >
                {companySelectOptions.map((item) => {
                  const isActive = (optionCompanyActive || []).some(
                    (activeItem) => String(activeItem?.value) === String(item?.value),
                  )
                  return (
                    <Option
                      key={item.value}
                      value={item.value}
                      style={isActive ? undefined : { display: 'none' }}
                    >
                      {item.label}
                    </Option>
                  )
                })}
              </Select>
            ) : (
              <div className="shim-select">
                <ShimmerButton size="sm" />
              </div>
            )}
          </Form.Item>
        </Col>
        <Col className="col-responsive-width-container">
          <h4 className="label">Operation</h4>
          {!isLoadingMultiForm.operation ? (
            <Form.Item
              key={'operation_' + additionalId}
              className="size-form"
              // id={'operation_' + additionalId}
              name={'operation_' + additionalId}
              style={{ width: '434px' }}
            >
              {isEditMode ? (
                <OperationTree
                  id={'project_operation_' + additionalId}
                  RebaseCutterFunctionally={() => {}}
                  setAccountOptions={setAccountOptions}
                  selectedOperationData={tabCompanyData?.operation_code || []}
                  defaultOperationName={(tabCompanyData?.operation_code || [])
                    .map(
                      (item) =>
                        item?.operation_name ||
                        item?.name_en ||
                        item?.name_th ||
                        item?.name,
                    )
                    .filter(Boolean)
                    .join(',')}
                  masterData={masterDataEdit || []}
                  choiceCompany={choiceCompany}
                  choiceOperation={choiceOperations}
                  choiceSubOperation={subOperation}
                  setChoiceOperation={(e) => {
                    controllerOptionalOnChange({ action: 'operation', value: e })
                  }}
                  setChoiceSubOperation={(e) => {
                    controllerOptionalOnChange({ action: 'subOperation', value: e })
                  }}
                  disabled={choiceCompany.length <= 0}
                />
              ) : (
                <OperationTreeLegacy
                  RebaseCutterFunctionally={() => {}}
                  form={form}
                  setAccountOptions={setAccountOptions}
                  masterData={masterData}
                  selectedOperationData={tabCompanyData?.operation_code || []}
                  choiceCompany={choiceCompany}
                  choiceOperation={choiceOperations}
                  choiceSubOperation={subOperation}
                  setChoiceOperation={(e) => {
                    controllerOptionalOnChange({ action: 'operation', value: e })
                  }}
                  setChoiceSubOperation={(e) => {
                    controllerOptionalOnChange({ action: 'subOperation', value: e })
                  }}
                  disabled={choiceCompany.length <= 0}
                />
              )}
            </Form.Item>
          ) : (
            <div className="shim-select">
              <ShimmerButton size="sm" />
            </div>
          )}
        </Col>
      </Row>
      <Row style={{ display: 'flex', justifyContent: 'space-between' }}>
        <Col className="col-responsive-width-container">
          <h4 className="label">Project type</h4>

          {!isLoadingMultiForm?.suboperation ? (
            <Form.Item
              className="size-form"
              id={'suboperation_' + additionalId}
              name={'suboperation_' + additionalId}
              style={{ width: '434px' }}
            >
              {isEditMode ? (
                <SubOperationTree
                  RebaseCutterFunctionally={() => {}}
                  setAccountOptions={setAccountOptions}
                  selectedSubOperationData={tabCompanyData?.suboperation_code || []}
                  defaultSubOperationName={(tabCompanyData?.suboperation_code || [])
                    .map(
                      (item) =>
                        item?.sub_operation_name ||
                        item?.name_en ||
                        item?.name_th ||
                        item?.name,
                    )
                    .filter(Boolean)
                    .join(',')}
                  masterData={masterDataEdit || []}
                  choiceCompany={choiceCompany}
                  choiceOperation={choiceOperations}
                  choiceSubOperation={subOperation}
                  setChoiceSubOperation={(e) => {
                    controllerOptionalOnChange({
                      action: 'subOperation',
                      value: e,
                    })
                  }}
                  disabled={choiceOperations.length <= 0}
                />
              ) : (
                <SubOperationTreeLegacy
                  RebaseCutterFunctionally={() => {}}
                  form={form}
                  setAccountOptions={setAccountOptions}
                  masterData={masterData}
                  selectedSubOperationData={tabCompanyData?.suboperation_code || []}
                  choiceCompany={choiceCompany}
                  choiceOperation={choiceOperations}
                  choiceSubOperation={subOperation}
                  setChoiceSubOperation={(e) => {
                    controllerOptionalOnChange({
                      action: 'subOperation',
                      value: e,
                    })
                  }}
                  disabled={choiceOperations.length <= 0}
                />
              )}
            </Form.Item>
          ) : (
            <div className="shim-select">
              <ShimmerButton size="sm" />
            </div>
          )}
        </Col>

        <Col className="col-responsive-width-container">
          <h4 className="label">Project Group</h4>
          <Form.Item
            id={'project_group_' + additionalId}
            name={'project_group_' + additionalId}
            style={{ width: '434px' }}
          >
            {!isLoadingMultiForm.projectgroup > 0 ? (
              <TreeSelectProjectGroup
                // form={form}
                data={tabProjectGroupOptions}
                masterData={masterDataProjectGroup}
                selectedNameMap={selectedProjectGroupNameMap}
                choiceCompany={choiceCompany}
                choiceProjectGroup={choiceProjectGroup}
                setChoiceProjectGroup={(e) => {
                  controllerOptionalOnChange({
                    action: 'projectGroup',
                    value: e,
                  })
                }}
                setChoiceProjectCategory={(e) => {
                  controllerOptionalOnChange({
                    action: 'subProjectGroup',
                    value: e,
                  })
                }}
                disabled={choiceCompany.length <= 0}
              />
            ) : (
              <div className="shim-select">
                <ShimmerButton size="sm" />
              </div>
            )}
          </Form.Item>
        </Col>
      </Row>
      <Row style={{ display: 'flex', justifyContent: 'space-between' }}>
        <Col className="col-responsive-width-container">
          <h4 className="label">Strategic Direction</h4>
          <Form.Item
            id={'project_category_' + additionalId}
            name={'project_category_' + additionalId}
            style={{ width: '434px' }}
          >
            {!isLoadingMultiForm.projectcategory ? (
              <ProjectCategory
                data={tabProjectCategoryOptions}
                masterData={masterDataProjectGroup}
                selectedNameMap={selectedProjectCategoryNameMap}
                choiceCompany={choiceCompany}
                choiceProjectGroup={choiceProjectGroup}
                choiceProjectCategory={choiceProjectCategory}
                setChoiceProjectCategory={(e) => {
                  controllerOptionalOnChange({
                    action: 'subProjectGroup',
                    value: e,
                  })
                }}
                disabled={choiceCompany.length <= 0 || choiceProjectGroup.length <= 0}
              />
            ) : (
              <div className="shim-select">
                <ShimmerButton size="sm" />
              </div>
            )}
          </Form.Item>
        </Col>
        <Col className="col-responsive-width-container">
          <h4 className="label">Impact Type</h4>
          <Form.Item
            id={'project_img_type_' + additionalId}
            name={'project_img_type_' + additionalId}
            style={{ width: '434px' }}
          >
            {!isLoadingMultiForm.impacttype ? (
              <TreeSelectImpactType
                data={tabImpactTypeOptions}
                masterData={masterDataImpactType}
                selectedNameMap={selectedImpactTypeNameMap}
                choiceImpactTypeInactive={choiceImpactTypeInactive}
                choiceCompany={choiceCompany}
                choiceImpactType={choiceImpactType}
                setChoiceImpactType={(e) => {
                  controllerOptionalOnChange({
                    action: 'impact_type',
                    value: e,
                  })
                }}
                disabled={choiceCompany.length <= 0}
              />
            ) : (
              <div className="shim-select">
                <ShimmerButton size="sm" />
              </div>
            )}
          </Form.Item>
        </Col>
      </Row>
    </div>
  )
}

export default AdditionalBusiness
